import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface InlineDropdownProps {
  value: string | null;
  placeholder?: string;
  disabled?: boolean;
  open?: boolean;

  onClick: (
    event: React.MouseEvent<HTMLElement>
  ) => void;
}

const InlineDropdown: React.FC<InlineDropdownProps> = ({
  value,
  placeholder = "Select...",
  disabled = false,
  open = false,
  onClick,
}) => {
  return (
    <Box
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      onClick={disabled ? undefined : onClick}
      onKeyDown={(event) => {
        if (
          !disabled &&
          (event.key === "Enter" || event.key === " ")
        ) {
          event.preventDefault();
        }
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",

        width: "100%",
        minHeight: 40,

        px: 1,

        borderRadius: "4px",
        border: "1px solid",
        borderColor: "primary.main",

        cursor: disabled ? "default" : "pointer",

        color: disabled
          ? "text.disabled"
          : "text.primary",

        "&:hover": {
          borderColor: "#ddd"
        },

        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "primary.main",
          outlineOffset: "-2px",
        },
      }}
    >
      <Typography
        variant="body2"
        noWrap
        sx={{
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value || placeholder}
      </Typography>

      {open ? (
        <ArrowDropDownIcon
          fontSize="small"
          sx={{
            flexShrink: 0,
            color: disabled
              ? "text.disabled"
              : "text.secondary",
            transform: "rotate(-180deg)",
          }}
        />
      ) : (
        <ArrowDropDownIcon
          fontSize="small"
          sx={{
            flexShrink: 0,
            color: disabled
              ? "text.disabled"
              : "text.secondary",
          }}
        />
      )}
    </Box>
  );
};

export default InlineDropdown;